import type { CSSProperties } from 'react';
import type { TutorLink } from '@peach/types/tutors/tutor-link.dto.js';
import { PlatformIcon, platformHex } from '@/lib/links/platform-icons';
import { prettyUrl } from '@/lib/links/pretty-url';

export function LinksCard({ links }: { links: TutorLink[] }) {
  return (
    <div className="rounded-[var(--sf-radius)] bg-[var(--sf-card)] px-3.5 py-3">
      <span className="sf-eyebrow text-badge font-bold text-[var(--sf-fnt)]">Elsewhere</span>

      <div className="mt-1.5 flex flex-col">
        {links.map((link) => {
          const brand = platformHex(link.platform) ?? 'var(--sf-ink)';
          return (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              style={{ '--brand': brand } as CSSProperties}
              className="mm-btn group flex items-center gap-3 border-t-[1.5px] border-[var(--sf-line)] py-2.5 first:border-t-0"
            >
              <span className="sf-tile flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-[10px] text-[var(--brand)] group-hover:bg-[var(--brand)] group-hover:text-white">
                <PlatformIcon platform={link.platform} className="h-[18px] w-[18px]" />
              </span>

              <span className="min-w-0 flex-1">
                <span className="block truncate text-p-3 font-bold leading-tight text-[var(--sf-ink)]">
                  {link.title}
                </span>
                <span className="sf-note block truncate">{prettyUrl(link.url)}</span>
              </span>

              <span
                aria-hidden
                className="flex-shrink-0 text-[var(--sf-fnt)] transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[var(--brand)]"
              >
                ↗
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
